module.exports = __webpack_public_path__ + "img/work-weixin-contact-me.db410974.jpg";